import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { Grid } from '@material-ui/core';
import AttachmentIcon from '@material-ui/icons/Attachment';
import config from '../../constants/blob_config.json';



import {mapDocumentToArray, mapLibraryPrefix} from '../../mappers/libraryDocumentMapper';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0
  },
  chip: {
    margin: theme.spacing(0.5)
  }
}));

const LibraryDocumentList = (props) => {
  const classes = useStyles();
  const {commeSeperatedDocument, onRemoveDocument, canEdit } = props;

  React.useEffect(
    () => {
     
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [commeSeperatedDocument]
  );

  const handleDelete = (documentToRemove) => {
    onRemoveDocument(documentToRemove);
  };

  const mappedDocuments = mapDocumentToArray(commeSeperatedDocument);

  if (!mappedDocuments && mappedDocuments.length) return;


  return (
    <React.Fragment>
        <List component="nav" aria-label="documents">
          {
            mappedDocuments.map((document) => {
              return (
          <Grid container>
            <Grid item xs={10}>
                {canEdit ? <a
                    className={classes.documentLink}
                    href={mapLibraryPrefix(document) + document}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {document}
                  </a>  : {document} }
                  </Grid>

                  {canEdit &&  <Grid item xs={2}>
                <Button
                  startIcon={<DeleteIcon />}
                  className={classes.deleteButton}
                  onClick={()=>handleDelete(document)}
                >
                  Remove
                </Button>
            </Grid> }
            </Grid>
              );
            })}
        </List>
    </React.Fragment>
  );
};

export default LibraryDocumentList;
